<template>
  <div>
    <!-- cabecera -->
    <b-row
      v-if="!errorContent.table"
      class="mb-2"
    >
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col cols="8">
              <label>Inscripciones</label>
              <plan-select
                :plan-id.sync="inPlan"
                @change="onPlanChange"
              />
            </b-col>
            <b-col
              v-if="inPlan != null"
              cols="2"
            >
              <label>Periodos</label>
              <periodo-select
                :periodo-id.sync="inPeriodo"
                :auto-select-first="true"
                :plan-id="inPlan"
              />
            </b-col>
            <b-col cols="2">
              <label>Estatus</label>
              <v-select
                id="statusSelect"
                v-model="configRequest.status"
                placeholder="Filtre por estatus"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :reduce="val => val.value"
                :options="OrdeneStatusOptions"
                label="label"
                class="w-75"
              />
            </b-col>
            <!-- estado de cuenta -->
            <!-- <b-col
              cols="12"
              class="text-center"
            >
              <b-card-text>Seleccione plan de estudios e Ingrese a la orden deseada para subir su comprobante de pago.</b-card-text>
              <b-button
                variant="primary"
                @click="shwEC = true"
              >
                Estado de cuenta
              </b-button>
            </b-col> -->
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <!-- tabla de ordenes  -->
    <b-overlay
      :show="isBusyTable"
      rounded="lg"
    >
      <b-card no-body>
        <b-card-body>
          <b-row>
            <!-- filtros -->
            <b-col
              md="3"
              class="my-1"
            >
              <b-form-group
                label-for="statusSelect"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <v-select
                    id="statusSelect"
                    v-model="inStatus"
                    placeholder="Filtre por estatus"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :reduce="val => val.value"
                    :options="OrdeneStatusOptions"
                    label="label"
                    class="w-75"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              md="5"
              class="my-1"
            />
            <!-- search -->
            <b-col
              md="4"
              class="my-1"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-input-group
                  id="e-buscador"
                  class="input-group-merge"
                >
                  <b-input-group-prepend is-text>
                    <feather-icon
                      :class="{ 'text-danger cursor-pointer': searchQuery != '' }"
                      :icon="searchQuery != '' ? 'XIcon' : 'SearchIcon'"
                      @click="searchQuery != '' ? searchQuery = '' : ''"
                    />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="searchQuery"
                    :placeholder="(userRol.id != 1) ? 'Buscar nombre, referencia, matricula' : 'Escriba aqui'"
                  />
                </b-input-group>
              </div>
            </b-col>

            <!-- Table items -->
            <b-col cols="12">
              <b-table
                ref="refDataListTable"
                striped
                hover
                responsive
                :items="fetchData"
                :fields="tableColumns"
                primary-key="id"
                :sort-by.sync="sortBy"
                show-empty
                empty-text="Puede filtrar los resultados"
                :sort-desc.sync="isSortDirDesc"
              >
                <!-- aportaciones -->
                <template #cell(pagos)="row">
                  <b-badge :variant="frmAbonos(row.item).color">
                    <feather-icon
                      :icon="frmAbonos(row.item).icon"
                      class="mr-25"
                    />
                    {{ frmAbonos(row.item).text }}
                  </b-badge>
                </template>
                <!-- matricula -->
                <template #cell(matricula)="row">
                  <b-badge
                    :variant="(row.item.persona_fk) ? 'light-primary' : 'light-warning' "
                  >
                    {{ (row.item.persona_fk) ? 'Inscripcion' : row.item.matricula }}
                  </b-badge>
                </template>
                <!-- Aportacion -->
                <template #cell(precioFinal)="row">
                  {{ formatMoney(row.item.precioFinal) }}
                </template>
                <!-- Limite de Pago -->
                <template #cell(limitePago)="row">
                  {{ (row.item.limitePago) ? fechaOrden(row.item.limitePago, 'tecnico', false) : 'N/A' }}
                </template>
                <!-- status -->
                <template #cell(status)="row">
                  <b-badge :variant="frmstatus(row.item.status).color">
                    {{ frmstatus(row.item.status).text }}
                  </b-badge>
                </template>
                <!-- registrado -->
                <template #cell(fecha)="data">
                  <b-media vertical-align="center">
                    <small>{{ fechaOrden(data.item.fecha, 'tecnico') }}</small>
                  </b-media>
                </template>

                <!-- Column: Opciones -->
                <template #cell(opciones)="data">
                  <div class="text-nowrap text-center">
                    <!-- Ver Orden -->
                    <b-link
                      class="font-weight-bold text-secondary"
                      :to="`/compras/preview/${shipcode(data.item.id)}/`"
                    >
                      <feather-icon
                        :id="`client-row-${data.item.id}-detalle-icon`"
                        icon="CoffeeIcon"
                        class="text-success cursor-pointer mr-1"
                        size="16"
                      />
                    </b-link>

                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-overlay>
    <!-- modal para estado de cuenta -->
    <b-modal
      id="modal-detalle-persona"
      v-model="shwEC"
      :title="`Hola ${infoAccount.nombre} ${infoAccount.apellidoPaterno}`"
      hide-footer
      centered
      size="lg"
      @hide="shwEC = false"
    >
      <!-- detalle persona -->
      <section class="p-1">
        <estado-cuenta
          :matricula="parseInt(infoAccount.matricula, 10)"
          :fill-info="false"
        />
      </section>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  // BCardText,
  BRow,
  BCol,
  BTable,
  BMedia,
  BModal,
  BLink,
  BOverlay,
  BBadge,
  VBToggle,
  BFormGroup,
  // BFormSelect,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
  // BButton,
} from 'bootstrap-vue'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import {
  ref, onMounted, watch, computed,
} from '@vue/composition-api'
import {
  lastUpdate, formTransac, frmstatus, frmAbonos, fechaOrden, formatMoney,
} from '@core/utils/filter'
import { isEmptyObject, shipcode } from '@core/utils/utils'
import PlanSelect from '@core/components/selects/PlaneSelect.vue'
import PeriodoSelect from '@core/components/selects/PeriodoSelect.vue'
// import { useToast } from 'vue-toastification/composition'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useFillDataTable } from '@core/components/data-table/useFillDataTable'
import {
  useServicioEscolarCatalogos, configTableRequests,
} from '@/views/campus/components/compras/ConfigCompras'
import { rolesActions } from '@core/mixins/account-data/roles'
// import selectplan from '@/views/components/select-plan.vue'
import EstadoCuenta from '../compras-preview/components/estadoCuenta.vue'

export default {
  components: {
    BCard,
    BCardBody,
    // BCardText,
    BRow,
    BCol,
    BTable,
    BMedia,
    BModal,
    BLink,
    BOverlay,
    BBadge,
    EstadoCuenta,
    // selectplan,
    BFormGroup,
    // BFormSelect,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
    // BButton,
    'v-select': vSelect,
    PlanSelect,
    PeriodoSelect,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  mixins: [rolesActions],
  setup() {
    const inPlan = ref(null)
    const inPeriodo = ref(null)
    const inStatus = ref(null)
    const nivelPlan = ref(null)

    const idplan = ref(null)
    const totalRows = ref(1)
    const infoAccount = computed(() => store.state.cuenta.info)
    const loader = ref({ filters: false })
    const errorContent = ref({ filters: false, table: false })
    const idAspiranteSelected = ref({})
    const { tableColumns, configRequest } = configTableRequests()
    const { OrdeneStatusOptions } = useServicioEscolarCatalogos()
    const shwEC = ref(false)
    const {
      //* Fetching data
      fetchData, refetchData, refDataListTable, dataAux,
      //* Pagination
      // dataMeta,
      //* Table dynamic params
      dynamicParamRequest,
      //* Basic filters & pagination
      totalItems, perPageOptions, sortBy, searchQuery, isSortDirDesc,
      //* Loader
      isBusyTable,
      //* Error
      errorRequest,
    } = useFillDataTable()

    isSortDirDesc.value = false

    // reload table from api
    const FiltrarxPlanStudios = inplan => {
      configRequest.value.wsParams.plan = inplan
      configRequest.value.status = null
    }

    //* If the flag 'errorRequest' from data request is true, hide table content
    watch(errorRequest, error => { if (error) errorContent.value.table = error })
    // FILL FROM API
    // FILL DATOS FROM API
    watch([() => configRequest.value.wsParams.plan, () => configRequest.value.status], ([plan, status]) => {
      if (plan != null && status == null) {
        refetchData(true) // call api
      } else if (status != null && plan != null) {
        refetchData(false)
      } else if (plan == null && status == null) {
        refetchData(true) // seteamos vacia la lista
      }
    }, { immediate: true })

    watch([inPlan, inPeriodo], ([plan, periodo]) => {
      configRequest.value.wsParams.plan = plan || null
      configRequest.value.wsParams.periodo = plan ? periodo || null : null
      if (plan && periodo) {
        refetchData(true)
      }
    })

    watch(inStatus, status => {
      configRequest.value.status = status || null
      refetchData()
    })

    const onPlanChange = plan => {
      if (!plan) return
      inPlan.value = plan.id
      nivelPlan.value = plan.nivel
      inPeriodo.value = null
      inStatus.value = null
    }

    //* On mounted
    onMounted(() => {
      // configRequest.value.wsParams.plan = 1
      dynamicParamRequest.value = configRequest.value
      // Set the initial number of items
      // totalRows.value = dataAux.value.length
    })

    return {
      inPlan,
      inPeriodo,
      nivelPlan,
      inStatus,
      onPlanChange,

      totalRows,
      fetchData,
      tableColumns,
      totalItems,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataListTable,
      refetchData,
      dataAux,
      shwEC,
      idplan,
      // Filter
      lastUpdate,
      formTransac,
      OrdeneStatusOptions,

      // Extra Filters
      idAspiranteSelected,
      isEmptyObject,

      // Extra Filters
      configRequest,

      // Loader
      loader,
      isBusyTable,

      // Error
      errorContent,
      infoAccount,
      fechaOrden,
      formatMoney,
      frmstatus,
      frmAbonos,
      shipcode,
      FiltrarxPlanStudios,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
